module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('strong', [_vm._v("I GOT RUBBER BAND BANKS IN MY POCKET")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“WHATEVER YOU LIKE”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("PAPER TRAIL")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("T.I.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I carry such large amounts of cash around with me that a wallet would quickly wear out as it would be stretched beyond the capacity to hold the currency for which it was designed. A common alternative to the wallet, the money clip, is pushed beyond its mechanical limit as well. Therefore, a large rubber band will be employed, as it can expand with increased capacity.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e694d39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01ch02.vue
// module id = 84
// module chunks = 0